export const globalLoaderIncrement = () => ({ type: "GLOBAL_LOADER/INCREMENT" });
export const globalLoaderDecrement = () => ({ type: "GLOBAL_LOADER/DECREMENT" });
export const globalLoaderReset = () => ({ type: "GLOBAL_LOADER/RESET" });

